/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function _getProductMetafield(productData, namespace, key) {
    if (productData.hasOwnProperty('metafields')) {
        var metafieldValue = productData['metafields'].filter(function(e) { return e.namespace == namespace && e.key == key; });
        if (typeof metafieldValue[0] !== 'undefined') {
            return metafieldValue[0]['value'];
        }
    }
    return null; //Return null if metafield does not exist
};

const iswView = {
   updateProductItemISW: (componentRegistry) => {
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                 let productData = element.getParams().props.product;
                 let productId = productData.id;
                 let productItem = document.querySelector('[data-id="' + productId + '"]');
                 const headerOfProducts = document.querySelector('.boost-sd__header-item').innerText;
                 const productList = document.querySelector('.boost-sd__instant-search-product-list');
                 const limitProdut = "<span class='boost-sd-text'> Showing 5 Out Of 7</span>";
                 const collectionSale = productData.collections.filter(col => col.handle == 'deals-end-functionality');

                 //console.log(headerOfProducts)

                 if(headerOfProducts == 'Suggested Categories...' && !productList.querySelector('.boost-sd-text')){
                   productList.querySelector('.boost-sd__header-item').insertAdjacentHTML('beforeend', limitProdut);  
                 }
                
                 if(collectionSale.length > 0){
                   productItem.querySelector('.boost-sd__format-currency span').style.color = "red";
                 }
                

                 
               
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      }
     );
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([iswView.updateProductItemISW]);

const searchView = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
                try {
                    // Start customization--------------------------------------------
                    let productData = element.getParams().props.product;
                    let productId = productData.id;
                    if (productData?.split_product) {
                       productId = productData.variant_id;
                    }
                    let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                    let parent = productItem.querySelector('.boost-sd__product-info')
                    let sku = document.createElement("span");
                    let texSKU = document.createTextNode("SKU: " + productData.skus);
                    const collectionSale = productData.collections.filter(col => col.handle == 'deals-end-functionality');
                    sku.classList.add("boost-sd-sku");
                    const skuHTML = `<span class="boost-sd__sku-cont">SKU: <span class="boost-sd__sku">${productData.skus}</span>`
                    if (productItem) {
                       /* use pure js here */
                      if(!productItem.querySelector('.boost-sd__sku-cont')){
                        // sku.appendChild(texSKU);
                        // parent.insertBefore(sku, parent.children[1]);
                        productItem.querySelector(".boost-sd__product-title").insertAdjacentHTML("afterend", skuHTML)
                      }
                      if(collectionSale.length > 0){
                           productItem.querySelector('.boost-sd__format-currency span').style.color = "red"
                        }

                      if(_getProductMetafield(productData, 'custom','search_data_description_') !== null && _getProductMetafield(productData, 'custom','search_product_data_description') !== null && _getProductMetafield(productData, 'custom','search_data_description_product') !== null){
                        let metafieldDescription = `<div class='boost-sd-metafield-description' >
                             <ul>
                                <li>${_getProductMetafield(productData, 'custom','search_data_description_')}</li>
                                <li>${_getProductMetafield(productData, 'custom','search_product_data_description')}</li>
                                <li>${_getProductMetafield(productData, 'custom','search_data_description_product')}</li>
                                <li>${_getProductMetafield(productData, 'custom','search_description_')}</li>
                                <li>${_getProductMetafield(productData, 'custom','product_search_description')}</li>
                              </ul>
                            </div>`
                        if (!productItem.querySelector('.boost-sd-metafield-description')) {
                          productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', metafieldDescription);
                        }
                        
                      }

                      if(_getProductMetafield(productData, 'custom','product_search_content_delivery') !== null && _getProductMetafield(productData, 'custom','product_search_giant_price') !== null && _getProductMetafield(productData, 'custom','product_search_giant_guarantee') !== null){
                        let metafieldDetail = `<div class='boost-sd-metafield-detail' style="display: grid">
                          
                                <span><img src="${_getProductMetafield(productData, 'custom','product_search_icon_truck')}" alt="product_search_icon_truck" width="17" height="13"> ${_getProductMetafield(productData, 'custom','product_search_content_delivery')}</span>
                                <span><img src="${_getProductMetafield(productData, 'custom','product_search_icon_tick')}" alt="product_search_icon_tick" width="17" height="10"> ${_getProductMetafield(productData, 'custom','product_search_giant_price')}</span>
                                <span><img src="${_getProductMetafield(productData, 'custom','product_search_icon_right_tick_')}" alt="product_search_icon_right_tick_" width="17" height="10"> ${_getProductMetafield(productData, 'custom','product_search_giant_guarantee')}</span>
                                <span><img src="${_getProductMetafield(productData, 'custom','product_search_icon_right_tick_last')}" alt="product_search_icon_right_tick_last" width="17" height="10"> ${_getProductMetafield(productData, 'custom','product_search_text')}</span>
                           
                            </div>`

                           if (!productItem.querySelector('.boost-sd-metafield-detail')) {
                             productItem.querySelector('.boost-sd__inventory-status').insertAdjacentHTML("afterend", metafieldDetail);
                             productItem.querySelector('.boost-sd__product-image-row.boost-sd__product-image-row--bottom').style.bottom = '40px'
                           }
                         
                       }
                       
                      if(productItem.querySelector(".jdgm-prev-badge__text")){
                        productItem.querySelector(".jdgm-prev-badge__text").innerHTML = `(${productData.review_count})`
                      }
                      
                      
                    }
                    // End-------------------------------------------------------------
                 } catch (e) {
                    console.warn(e);
                 }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([searchView.updateProductItemGrid]);

function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/' + value + '?view=boost-sd-integration-compare-price');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
}

/**
* Get all shipping time, shipping price, shipping type, product type, text, and location data
* for this particular suburb
* 
* @param int suburbId - Database primary key id of the suburb 
* @returns {*} with data from strapi
*/
async function loadShippingTimesInternal(suburbId, shopifyProductId, stock, stockBuffer, productType, stockArrivalDate = ""){
    
  // console.log("Calling loadShipping");
  const res = await fetch(`https://api.agstark.com/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}`);

  const data = await res.json();

  return data.data;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        let productHandle = '';
                        if (element.getParams().props && element.getParams().props.product) {
                            productHandle = element.getParams().props.product.handle;
                        }

                        let requestReg = formRequest(productHandle);
                        requestReg.then((res_success) => {
                            let res = JSON.parse(res_success);
                            
                            let productItem = document.querySelector(`.boost-sd__product-item[data-product-id="` + res.id + `"] `);

                            if(!productItem.querySelector('.wrapper_compare_discount')){
                                productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('beforeend', res.compare_price);
                                productItem.querySelector('.boost-sd__inventory-status').style.top =  '78px';
                            }

                            if(!productItem.querySelector('.inventoryNote')){
                                productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('beforeend', res.availabel_order);
                               
                                //CUSTOM COM GUYS
                                let storedSuburbIdMain = localStorage.getItem("agSitePostStateId");
                                storedSuburbIdMain = storedSuburbIdMain ? storedSuburbIdMain : null;

                                const noDelivery = storedSuburbIdMain ? `Unfortunately we are unable to deliver this item to your region yet. Please select a different delivery postcode or contact us on 1300 444 268 or via live chat to discuss further.` : `Please enter your postcode to view the available delivery dates for your region.`;

                                const theDateSpan = productItem.querySelector(`#productdate${res.id}`); //this will be update by JS

                                const osSpan =  productItem.querySelector(`#outofstock${res.id}`);//if not null then we do an api call
                                const inStockSpan =  productItem.querySelector(`#instock${res.id}`);//if not null then we do an api call
                                const lowStockSpan =  productItem.querySelector(`#lowstock${res.id}`);//if not null then we do an api call

                                const stockBuffer =  productItem.querySelector(`#stockBuffer${res.id}`);
                                const stockBufferValue = stockBuffer.innerText ? parseInt(stockBuffer.innerText) : 0;

                                const stockLevel =  productItem.querySelector(`#stockLevel${res.id}`);
                                const stockLevelValue = stockLevel.innerText ? parseInt(stockLevel.innerText) : 0;


                                const productType = productItem.querySelector(`#productType${res.id}`).innerText;

                                
                                const mainProductSpan = productItem.querySelector(`#mainProductSpan${res.id}`);

                                //Only call the api if WE HAVE A SUBURB AND A PRODUCT TYPE SET
                                if(storedSuburbIdMain && productType){

                                    //Get ship time data from the api
                                    const shipTimes = loadShippingTimesInternal(storedSuburbIdMain, res.id, stockLevelValue, stockBufferValue, productType);

                                    shipTimes.then((shipTimeRes) => {
                                        
                                        //OUT OF STOCK
                                        if(osSpan){
                                            //Updating the shipping date on the frontend
                                            if(shipTimeRes[0]?.dateStartText){
                                                theDateSpan.innerHTML = `${shipTimeRes[0].dateStartText}.`;
                                            } else {
                                                mainProductSpan.innerHTML = noDelivery;
                                            }
                                        }

                                        //IN STOCK
                                        if(inStockSpan){
                                            //Updating the shipping date on the frontend
                                            if(shipTimeRes[0]?.dateStartText){
                                                mainProductSpan.innerHTML = `Delivery ${shipTimeRes[0].by_or_between} ${shipTimeRes[0].opinionatedDateText}.`;
                                            } else {
                                                mainProductSpan.innerHTML = noDelivery;
                                            } 
                                        }

                                        //LOW STOCK
                                        if(lowStockSpan){
                                            //Updating the shipping date on the frontend
                                            if(shipTimeRes[0]?.dateStartText){
                                                mainProductSpan.innerHTML = `Less than 2 remaining in stock. Be quick! Delivery ${shipTimeRes[0].by_or_between} ${shipTimeRes[0].opinionatedDateText}.`;
                                            } else {
                                                mainProductSpan.innerHTML = noDelivery;
                                            } 
                                        }

                                    }).catch((res_error) => {
                                        //console.log(res_error)
                                    });
                                } else {
                                    mainProductSpan.innerHTML = noDelivery;
                                }
                                
                                //END CUSTOM COM GUYS

                                productItem.querySelector('.inventoryNote').style.marginTop  =  '41px';
                           }
                             
                          
                         // console.log(res.compare_price)
                        }).catch((res_error) => {
                            //console.log(res_error)
                        });
                    },
                };
            },
        });

    }
]);